import { type ReactElement, type ReactNode, useState } from 'react';

interface PanelElementProps {
	title: string;
	children?: ReactNode;
}

interface TabProps {
	selected: number;
	children: ReactElement<PanelElementProps>[];
}

export const Tabs = ({ selected, children }: TabProps) => {
	const [currentIdx, setCurrentIdx] = useState(selected);

	const handleChange = (index: number) => {
		setCurrentIdx(index);
	};

	return (
		<>
			<div className="tab-group">
				{children.map((elm: ReactElement<PanelElementProps>, index: number) => {
					const isActive = index === currentIdx;
					return (
						<button
							className={isActive ? 'active' : ''}
							type="button"
							key={`${index.toString()}`}
							onClick={() => handleChange(index)}
						>
							{elm.props.title}
						</button>
					);
				})}
			</div>
			<div className="tab-content">{children[currentIdx]}</div>
		</>
	);
};

interface PanelProps {
	title: string;
	children: ReactNode;
}

export const Panel = ({ ...props }: PanelProps): ReactElement => {
	const { children } = props;
	return children as ReactElement;
};
